import React, { useState } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import prettier from 'prettier/standalone';
import htmlParser from 'prettier/parser-html';
import 'codemirror/addon/fold/xml-fold'; // Required for folding in XML/HTML mode
import { Button } from '@arco-design/web-react';
import { IconCode } from '@arco-design/web-react/icon';

// MUI -> Arco. Only the Format button wrapper is converted (Button contained ->
// type="primary", startIcon -> icon; DataObjectIcon -> IconCode); the CodeMirror
// logic is untouched.
const SourceEmailEditor = (props) => {
    const { htmlContent, setHtmlContent } = props;
    //   const [code, setCode] = useState('<p>Hello, world!</p>');

    const handleChange = (editor, data, value) => {
        setHtmlContent(value);
    };

    const formatCode = () => {
        try {
            const formattedCode = prettier.format(htmlContent, {
                parser: 'html',
                plugins: [htmlParser],
            });
            setHtmlContent(formattedCode);
        } catch (error) {
            console.error('Error formatting code:', error);
        }
    };

    const lines = htmlContent && htmlContent.split("\n") || [];
    const theContent = lines.length > 10 ? htmlContent : htmlContent + "\n".repeat(10 - lines.length)

    return (
        <>
            <CodeMirror
                value={theContent}
                options={{
                    mode: 'htmlmixed',
                    theme: 'monokai',
                    lineNumbers: true,
                    // autoClearEmptyLines: false,
                    // viewportMargin: Infinity,
                    // minHeight: 300,
                    // height: Math.min(700, htmlContent.split('\n').length * 20 + 50),
                    // viewportMargin: Infinity,
                    // minHeight: 300,
                    // maxHeight: 700,
                }}
                onBeforeChange={handleChange}
            />
            {/* <Button onClick={formatCode}>Format Code</Button> */}
            <Button
                type="primary"
                icon={<IconCode />}
                onClick={formatCode}
            >
                Format
            </Button>

        </>
    );
};

export default SourceEmailEditor;
